import {cva} from "class-variance-authority";

export const sidebarStyles = cva('bg-nav-bg text-white h-[calc(100vh-var(--banner-height))] top-[var(--banner-height)] flex fixed border-r border-nav-hover', {
    variants: {
        isMobile: {
            true: 'w-20',
        }
    }
});

export const activityStyles = cva('h-[10px] w-[10px] rounded-full border border-white', {
    variants: {
        status: {
            DND: 'bg-danger',
            TALKING: 'bg-warning',
            OFFLINE: 'bg-fill-subtle',
            ONLINE: 'bg-success',
            default: 'bg-fill-subtle',
        }
    }
} );
export const sidebarAvatarStyles = cva('flex pt-5 pb-10 justify-center  ', {
    variants: {
        isMobile: {
            true: 'px-5 mx-0',
        }
    }
});
